import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkboxTitle',
  pure: false,
  standalone: true
})
export class CheckboxTitlePipe implements PipeTransform {
  transform(checked: boolean, rowDescription?: string): string {
    if (!rowDescription) {
      return `${checked ? 'Deselect' : 'Select'} all`;
    }
    return `${checked ? 'Deselect' : 'Select'} row ${rowDescription}`;
  }
}
